import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import Address from '~/types/Address';
import Manifest, { ManifestsDateRangeByAddress } from '~/types/Manifests';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type ManifestMap = Readonly<Record<string, Manifest>>;

export type ManifestsState = {
  readonly manifestGroups: Requestable<Readonly<ManifestsDateRangeByAddress>, Error>;
  readonly selectedCarrier: string;
  readonly addresses: readonly Address[];
  readonly selectedDate?: Date;
  readonly selectedDateRangeStart?: Date;
  readonly selectedDateRangeEnd?: Date;
  readonly selectedAddress: string;
  readonly isLoading: boolean;
  readonly isCreateLoading: boolean;
  readonly createManifestErrors: readonly string[];
  readonly manifests: Requestable<ManifestMap, Error>;
  readonly downloadingDocumentsManifestID?: number;
};
export const initialState: ManifestsState = {
  manifestGroups: getNotRequested(),
  addresses: [],
  selectedCarrier: '',
  selectedDate: undefined,
  selectedDateRangeStart: undefined,
  selectedDateRangeEnd: undefined,
  selectedAddress: '',
  isLoading: false,
  isCreateLoading: false,
  createManifestErrors: [],
  manifests: getNotRequested(),
  downloadingDocumentsManifestID: undefined,
};

function manifests(state: ManifestsState = initialState, action: ActionTypes): ManifestsState {
  switch (action.type) {
    case ActionKeys.MANIFESTS_FETCH:
      return {
        ...state,
        manifests: getRequesting(),
      };
    case ActionKeys.MANIFESTS_FETCH_SUCCESS:
      const manifestsMap = action.payload.reduce((hashMap: Record<string, Manifest>, manifest) => {
        hashMap[manifest.objectId] = manifest;
        return hashMap;
      }, {});
      return {
        ...state,
        manifests: getSuccess(manifestsMap),
      };
    case ActionKeys.MANIFESTS_FETCH_SUCCESS_TERMINAL_STATE:
      if (state.manifests.kind === 'success') {
        const manifestsCopy = { ...state.manifests.data };
        for (const manifest of action.payload) {
          manifestsCopy[manifest.objectId] = manifest;
        }
        return {
          ...state,
          manifests: getSuccess(manifestsCopy),
        };
      }
      return state;
    case ActionKeys.MANIFESTS_DOWNLOAD_ZIP:
      return {
        ...state,
        downloadingDocumentsManifestID: action.payload,
      };
    case ActionKeys.MANIFESTS_DOWNLOAD_ZIP_SUCCESS:
    case ActionKeys.MANIFESTS_DOWNLOAD_ZIP_ERROR:
      return {
        ...state,
        downloadingDocumentsManifestID: undefined,
      };
    case ActionKeys.MANIFESTS_FETCH_ERROR:
      return {
        ...state,
        manifests: getFailed(action.payload),
      };
    case ActionKeys.MANIFESTS_GROUPS_FETCH:
      return {
        ...state,
        selectedDate: action.payload.submissionDate,
        selectedDateRangeStart: action.payload.dateRangeStart,
        selectedDateRangeEnd: action.payload.dateRangeEnd,
        selectedCarrier: action.payload.carrierObjectId,
        manifestGroups: getRequesting(),
      };
    case ActionKeys.MANIFESTS_UPDATE_ADDRESS:
      return {
        ...state,
        selectedAddress: action.payload.address,
      };
    case ActionKeys.MANIFESTS_GROUPS_FETCH_SUCCESS:
      return {
        ...state,
        addresses: action.payload.addresses,
        manifestGroups: getSuccess(action.payload.ranges),
      };
    case ActionKeys.MANIFESTS_GROUPS_FETCH_ERROR:
      return {
        ...state,
        manifestGroups: getFailed(action.payload),
      };
    case ActionKeys.MANIFESTS_GENERATE:
      return {
        ...state,
        createManifestErrors: [],
        isCreateLoading: true,
      };
    case ActionKeys.MANIFESTS_GENERATE_SUCCESS:
      return {
        ...state,
        createManifestErrors: [],
        isCreateLoading: false,
      };
    case ActionKeys.MANIFESTS_GENERATE_ERROR:
      return {
        ...state,
        createManifestErrors: [...state.createManifestErrors, action.payload.message],
        isCreateLoading: false,
      };
    case ActionKeys.MANIFESTS_POLL_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionKeys.MANIFESTS_POLL_END:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

export default manifests;
